var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close Icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 11.1665L5.91671 15.2498C5.76393 15.4026 5.56949 15.479 5.33337 15.479C5.09726 15.479 4.90282 15.4026 4.75004 15.2498C4.59726 15.0971 4.52087 14.9026 4.52087 14.6665C4.52087 14.4304 4.59726 14.2359 4.75004 14.0832L8.83337 9.99984L4.75004 5.9165C4.59726 5.76373 4.52087 5.56928 4.52087 5.33317C4.52087 5.09706 4.59726 4.90261 4.75004 4.74984C4.90282 4.59706 5.09726 4.52067 5.33337 4.52067C5.56949 4.52067 5.76393 4.59706 5.91671 4.74984L10 8.83317L14.0834 4.74984C14.2362 4.59706 14.4306 4.52067 14.6667 4.52067C14.9028 4.52067 15.0973 4.59706 15.25 4.74984C15.4028 4.90261 15.4792 5.09706 15.4792 5.33317C15.4792 5.56928 15.4028 5.76373 15.25 5.9165L11.1667 9.99984L15.25 14.0832C15.4028 14.2359 15.4792 14.4304 15.4792 14.6665C15.4792 14.9026 15.4028 15.0971 15.25 15.2498C15.0973 15.4026 14.9028 15.479 14.6667 15.479C14.4306 15.479 14.2362 15.4026 14.0834 15.2498L10 11.1665Z",
    fill: "#585858"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a59da6b9a315ad7794fb9a1c826aadbe.svg";
export { ForwardRef as ReactComponent };